import styled from "styled-components";

export const CalendarContainer = styled.div`
  width: 1470px;
  display: flex;
  flex-direction: column;
  align-items: center;
  .react-calendar {
    font-family: "Noto Sans KR", sans-serif;
    width: 1470px;
    border: 0;
    background-color: ${(props) => props.theme.white1};
  }
  .react-calendar__navigation {
    display: none;
  }
  .react-calendar__month-view__weekdays {
    display: none !important;
  }
  .react-calendar__tile {
    padding: 5px 10px;
    background-color: ${(props) => props.theme.white0};
    border-top: 5px solid ${(props) => props.theme.black1};
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    max-width: 200px;
    height: 91px;
    display: flex;
    align-items: left;
    flex-direction: column;
    font-size: 15px;
    color: ${(props) => props.theme.black1};
    font-weight: 800;
    margin-left: 10px;
    margin-bottom: 10px;
    .memo {
      margin-left: 40px;
      margin-top: 5px;
    }
    h6 {
      margin: 0;
      font-weight: 600;
      font-size: 13px;
    }
    p {
      margin: 0;
      font-weight: 400;
      font-size: 12px;
      text-align: left;
    }
  }
  .react-calendar button:enabled:hover{
    cursor: unset;
  }

  .react-calendar__tile--sunday {
    border-top: 5px solid ${(props) => props.theme.red1};
  }
  
  .react-calendar__tile--saturday {
    border-top: 5px solid ${(props) => props.theme.blue1};
  }

  .react-calendar__tile--active:enabled:hover,
  .react-calendar__tile--active:enabled:focus,
  .react-calendar__tile--active {
    background: unset;
    color: unset;
    border-color: unset;
  }
  .react-calendar__tile:hover {
    background-color: ${(props) => props.theme.colorwhite2};
  }
  .react-calendar__tile--now:enabled:hover,
  .react-calendar__tile--now:enabled:focus,
  .react-calendar__tile--now,
  .react-calendar__tile--now:hover {
    background: ${(props) => props.theme.colorwhite3};
    border-color: ${(props) => props.theme.teal1};
  }
  .react-calendar__tile--not-current-month {
    visibility: hidden;
    
  }
  .search:hover{
    cursor: pointer;
    color: ${(props) => props.theme.blue1};
  }
`;

export const SmallSpan = styled.span`
  width: 130px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
